export default __webpack_public_path__ + "b362552e7a95d77cccf65fc9540bd99c.png";